const en = {
  languageName: "English",
  guestFallback: "Guest",
  genericError: "Something went wrong. Please try again.",
  checkMarkedFields: "Please check the highlighted fields.",
  imageReadError: "Selected image could not be read by the browser.",
  imageConvertError: "Selected image could not be converted to JPEG.",
  unsupportedImageFormat: "Please upload a JPEG, PNG, or WebP image.",
  reservationNotFound: "Reservation not found.",
  ownerOnly: "This check-in link is only available to the booking owner.",
  required: "{field} is required.",
  progress: "Progress",
  loading: "Preparing check-in...",
  selectPlaceholder: "Please select",
  back: "Back",
  continue: "Continue",
  saving: "Saving...",
  startCheckin: "Start check-in",
  uploadId: "Upload ID",
  confirmData: "Confirm data",
  complete: "Complete registration",
  checking: "Checking...",
  dismissError: "Dismiss error",
  checkin: "CHECK-IN",
  wordmark: "GUEST JOURNEY",
  language: "Language",
  overview: {
    kicker: "Online check-in",
    title: "YOUR RESERVATION",
    reservation: "Reservation",
    guest: "Guest",
    room: "Room",
    stay: "Stay",
    returningQuestion: "Are you {name}?",
    yes: "Yes, that's me",
    no: "No",
  },
  details: { title: "GUEST DETAILS" },
  purpose: { title: "YOUR STAY", question: "Is this stay private or business?", private: "Private", business: "Business" },
  idIntro: {
    title: "ID VERIFICATION",
    copy: "Scan or upload a valid identity document. You can review the details afterwards and add anything manually if needed.",
    copyIntro: "Scan or upload a valid identity document (",
    copyOutro: "). You can review the details afterwards and add anything manually if needed.",
    expressScan: "EXPRESS SCAN",
  },
  documents: {
    idCard: "ID card",
    passport: "Passport",
    driverLicense: "Driver license",
  },
  camera: {
    help: "Help",
    ready: "Looking for the back of ID...",
    requesting: "Starting camera...",
    denied: "Camera is not available. Please upload your document.",
    unavailable: "Your browser does not support camera capture.",
    helpText: "Keep the document flat, bright, and fully inside the frame.",
  },
  identity: {
    title: "ID VERIFICATION",
  },
  address: {
    title: "ADDRESS",
  },
  review: {
    title: "FINAL REVIEW",
    document: "Document",
    address: "Address",
    travelPurpose: "Travel purpose",
    terms: "I accept the terms and conditions.",
    privacy: "I have read the privacy notice.",
    contactPermission: "I would like to receive relevant information about my stay.",
    backendError: "Please check your details. Some required fields are missing or were not accepted by the backend.",
    nextGuest: "Continue to next guest",
    continueServices: "Continue to services",
  },
  services: {
    kicker: "Optional services",
    title: "SERVICES",
    selected: "Included and selected",
    selectedState: "Selected",
    included: "Included",
    includedState: "Included with your reservation",
    empty: "No optional services are offered for this reservation.",
    priceUnavailable: "Price unavailable",
    add: "Add service",
    remove: "Remove",
    skipOne: "Skip",
    retry: "Refresh services",
    licensePlate: "License plate",
    licensePlateRequired: "Please enter your license plate for parking.",
    pickupDate: "Taxi pickup date",
    pickupTime: "Taxi pickup time",
    pickupHour: "Hour",
    pickupMinute: "Minute",
    pickupNote: "Pickup note (optional)",
    taxiRequired: "Please choose a taxi pickup date and time.",
    taxiQuarterHour: "Choose a pickup time in 15-minute steps.",
    summary: "SERVICES SUMMARY",
    inBasket: "In your basket",
    basketTotal: "Selected extras",
    estimatedTotal: "Amount due",
    noneSelected: "No additional services selected.",
    booked: "Already booked",
    pendingRemoval: "To be removed",
    keep: "Keep service",
    quantity: "Quantity",
    quantityRequired: "Please enter an available quantity of at least 1.",
    breakfastAdults: "Adults",
    breakfastChildren: "Children 7–13",
    breakfastFreeChildren: "Children 0–6",
    breakfastTotal: "Breakfast total",
    breakfastGuestLimit: "Breakfast counts cannot exceed the guests in this room.",
    breakfastChildUnavailable: "Child breakfast is not available for this reservation or quantity.",
    free: "Free",
    notAvailable: "Not available",
    dates: "Service dates",
    datesRequired: "Please choose an available service date.",
    wholeStay: "Whole stay",
    sauna: "Sauna",
    saunaNoticeLead: "30 MIN",
    saunaNotice: "Please inform reception at least 30 minutes before you would like to use the sauna.",
    babyBed: "Baby bed",
    pet: "Pet",
    saveFailed: "The selected services could not be saved.",
    processing: "Preparing your stay...",
    uncertain: "The hotel has not confirmed whether the last change was saved. Please contact the hotel before trying again.",
  },
  payment: {
    kicker: "After services",
    title: "PAYMENT",
    balance: "Amount due",
    noneDue: "No payment required",
    charge: "Charge",
    unavailable: "Not available",
    due: "Please pay the open balance before check-in.",
    returned: "After paying, return here (or use your browser's Back button). Payment status is checked automatically.",
    confirmed: "Payment confirmed by the hotel system.",
    testOverride: "Backend test override is active. Payment is bypassed for this test.",
    pay: "Pay balance",
    checkAgain: "Check again",
    verifying: "Verifying your payment with the hotel system...",
    verificationUnavailable: "Payment verification is temporarily unavailable. We will keep checking.",
    verificationStopped: "Payment verification could not continue. Please reopen your guest link or contact the hotel.",
    pending: "Payment has not been confirmed yet. Please try again after paying.",
    pollTimeout: "Payment confirmation is taking longer than expected. Check again to refresh the balance.",
    linkUnavailable: "A payment link is not available. Please contact the hotel.",
    linkExpired: "The payment link has expired or no longer matches the balance. Please contact the hotel.",
  },
  completion: {
    title: "Online registration complete!",
    copy: "Your registration details have been submitted. Hotel check-in and room access remain controlled by the hotel system.",
    accessPin: "Your access code",
    roomAccessUnavailable: "Room access is not available yet",
    roomAccessUnavailableCopy: "Please contact the hotel reception for help with room access.",
    paymentRequired: "Payment required",
    goToCheckout: "Go to checkout",
    dryRun: "Development mode: Check-in was validated as a dry run.",
    continueToRoomJourney: "Continue to room app",
    backToBooking: "Back to booking",
    roomGuestLinks: "Room guest links",
    notConfirmed: "Registration was not confirmed by the hotel system. Please try again.",
  },
  fields: {
    email: "Email",
    phone: "Phone",
    travel_purpose: "Stay purpose",
    nationality_country_code: "Nationality",
    document_type: "Document type",
    document_number: "Document number",
    document_issued_on: "Issue date",
    date_of_birth: "Date of birth",
    gender: "Gender",
    street_name: "Street and house number",
    address_line_2: "Address addition optional",
    zip_code: "Postal code",
    city: "City",
    country_code: "Country",
    company_name: "Company name",
    company_vat_number: "VAT number (optional)",
    terms_accepted: "Terms and conditions",
    privacy_accepted: "Privacy notice",
  },
  countries: {
    DE: "Germany",
    AT: "Austria",
    CH: "Switzerland",
    NL: "Netherlands",
    FR: "France",
    IT: "Italy",
    ES: "Spain",
    GB: "United Kingdom",
    US: "United States",
  },
  documentTypes: {
    ID_CARD: "ID card",
    PASSPORT: "Passport",
    DRIVER_LICENSE: "Driver license",
  },
  genders: {
    MALE: "Male",
    FEMALE: "Female",
    DIVERSE: "Diverse",
  },
  travelPurposes: {
    BUSINESS: "Business",
    LEISURE: "Leisure",
    MIXED: "Combination of both",
    OTHER: "Other",
  },
};

export default en;
